import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PromoTileButton } from 'web-ui-components/lib/navigation/buttons';

import InternetBankingActions from '../../actions/InternetBankingActions';
import Modal from '../../components/common/modals/PatternLibModalComponent';
import UserManagementStore from '../../stores/UserManagementStore';
import { LetsChatDecisionModal } from './LetsChatDecisionModal';
import { storageAvailable } from '../../utils/LocalStorageUtils';

const dontShowLetsChatModalAgain = 'VM_HideLetsChatModal';
const TRUE = '1';

class SecureMessage extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleLetsChat = this.handleLetsChat.bind(this);
    this.setLocalStorageSecureMessageIBUserPreference =
      this.setLocalStorageSecureMessageIBUserPreference.bind(this);
    this.continueWithSecureMessaging =
      this.continueWithSecureMessaging.bind(this);
    this.handleDontShowAgainOnChange =
      this.handleDontShowAgainOnChange.bind(this);
    this.secureMessagePopupClose = this.secureMessagePopupClose.bind(this);

    this.state = {
      showModal: false,
      dontShowAgain: false,
    };
  }

  handleClick() {
    const localStorageDontShowAgainPref = storageAvailable('localStorage')
      ? window.localStorage.getItem(dontShowLetsChatModalAgain) ?? false
      : false;
    const shouldShowLetsChatModal = localStorageDontShowAgainPref !== TRUE;
    if (!UserManagementStore.isBusinessUser() && shouldShowLetsChatModal)
      this.setState({ showModal: true });
    else InternetBankingActions.navigateToWebTask('WEB-SECURE-MESSAGE');
  }

  setLocalStorageSecureMessageIBUserPreference() {
    if (this.state.dontShowAgain && storageAvailable('localStorage')) {
      window.localStorage.setItem(dontShowLetsChatModalAgain, TRUE);
    }
  }

  handleLetsChat() {
    try {
      window.Microsoft.Omnichannel.LiveChatWidget.SDK.startChat();
    } catch (error) {
      window.dtrum?.reportError(error);
    }
    this.setLocalStorageSecureMessageIBUserPreference();
    this.setState({ showModal: false });
  }

  continueWithSecureMessaging() {
    this.setLocalStorageSecureMessageIBUserPreference();
    InternetBankingActions.navigateToWebTask('WEB-SECURE-MESSAGE');
  }

  handleDontShowAgainOnChange() {
    this.setState((state) => ({ dontShowAgain: !state.dontShowAgain }));
  }

  secureMessagePopupClose() {
    this.setLocalStorageSecureMessageIBUserPreference();
    this.setState({ showModal: false });
  }

  render() {
    const { isLCV, content, count } = this.props;
    const isValid = count > 0;

    return (
      <div className={`${!isLCV && 'c-slab-min-height'} u-flex`}>
        <PromoTileButton
          onClick={this.handleClick}
          labelText={
            isValid
              ? `${content.youGot}${count}${
                  count === 1
                    ? content.oneSecureMessage
                    : content.newSecureMessages
                }`
              : content.secureMessages
          }
          icon="MailOutlineLarge"
        />
        {this.state.showModal && (
          <Modal
            show={this.state.showModal}
            onHide={this.secureMessagePopupClose}
            bsSize={'medium'}
            modalHeading={content.letsChatModalTitle}
            modalBody={
              <LetsChatDecisionModal
                continueWithSecureMessaging={this.continueWithSecureMessaging}
                handleLetsChat={this.handleLetsChat}
                dontShowAgain={this.state.dontShowAgain}
                handleDontShowAgainOnChange={this.handleDontShowAgainOnChange}
                content={content}
              />
            }
            customClass={'c-modal'}
          />
        )}
      </div>
    );
  }
}

SecureMessage.propTypes = {
  content: PropTypes.object,
  count: PropTypes.number,
};

export { SecureMessage };
